<template>
  <div class="login">
    <div
      id="information-box"
      ref="information"
    >
      <div class="information-tit">
        <img
          src="../assets/image/login/titt.png"
          alt=""
        >
      </div>
      <el-card class="information-login">
        <el-tabs v-model="activeName"
        class="el-tabs"
       >
          <el-tab-pane
            label="扫码登录"
            name="codeQR"                          
          >

            <div class="code-qr">
              <el-image
                :src="codeQrImg"
                alt="加载失败"
                class="qrPng"
              >
                <div
                  slot="error"
                  class="image-slot"
                >
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="账号登录"
            name="pw"
          >
            <div class="pw-box">
              <el-form
                ref="form"
                status-icon
                :model="form"
                :rules="rules"
              >
                <el-form-item prop="userCode">
                  <el-input
                    @keyup.enter.native="login"
                    placeholder="账户"
                    v-model="form.userCode"
                    prefix-icon="el-icon-user"                  
                  ></el-input>
                </el-form-item>
                <el-form-item prop="userPwd">
                  <el-input
                    @keyup.enter.native="login"
                    placeholder="密码"
                    type="password"
                    show-password
                    v-model="form.userPwd"
                    prefix-icon="el-icon-lock"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="verCode"
                  class="validate-container"
                >
                  <!-- :maxlength="4" -->
                  <el-input
                    v-model="form.verCode"
                    style="width:190px"
                    placeholder="验证码"
                    @keyup.enter.native="login"
                  />
                  <img
                    :src="validateImg"
                    class="validateImg"
                    @click="getVerCode"
                  >
                  <!-- <el-button
                    @click="getVerCode"
                    class="huan"
                    size="mini"
                  >换一换</el-button> -->
                </el-form-item>
                <div class="save-pw clearfix">
                  <div class="fl">
                    <el-checkbox v-model="autoLogin">30天内自动登录</el-checkbox>
                  </div>
                </div>
                <el-form-item>
                  <el-button
                    style="background:#21caaa"
                    class="loginBtn"
                    @click="login"
                  >登&nbsp;录</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>

        </el-tabs>
      </el-card>
    </div>
  </div>
</template>



<script>
import { postData, getData, postJson } from "@/http/fetch.js";
import { timeLocalStorage } from "@/utils/index";
import md5 from "js-md5";
export default {
  data() {
    return {
      activeName: "pw", //codeQR pw
      codeQrImg: require(`@/assets/image/login/qrcode.png`),
      validateImg: "",
      form: {
        userCode: "",
        userPwd: "",
        verCode: null,
        clientPackage: "com.xueduoduo.tree.pc",
      },
      rules: {
        userCode: [
          {
            required: true,
            message: "请输入用户名",
            trigger: ["blur", "change"],
          },
          {
            min: 3,
            max: 12,
            message: "长度必须是 3-12 位",
            trigger: ["blur", "change"],
          },
        ],
        userPwd: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["blur", "change"],
          },
          {
            min: 3,
            max: 12,
            message: "长度必须是 3-12 位",
            trigger: ["blur", "change"],
          },
        ],
        verCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: ["blur"],
          },
          {
            min: 4,
            max: 4,
            message: "长度必须是 4 位",
            trigger: ["blur"],
          },
        ],
      },
      autoLogin: false,

      //中心区域 大小自适应
      screenWidth: null, //屏幕尺寸
      screenHeight: null, //屏幕尺寸
    };
  },
  created() {
    //本地保存未失效 自动登录
    if (timeLocalStorage.get("autoLoginObj")) {
      let remeObj = timeLocalStorage.get("autoLoginObj");
      this.form.userCode = remeObj.userCode;
      this.form.userPwd = window.atob(remeObj.userPwd); //base64
      this.autoLogin = true;
      this.$axios.get("/oauth/getVerCode").then((res) => {
        this.form.verCode = res;
        this.login();
      });
    } else {
      this.getVerCode();
    }
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;
    this.screenHeight = document.body.clientHeight;
    window.onresize = () => {
      //屏幕尺寸变化就重新赋值
      return (() => {
        this.screenWidth = document.body.clientWidth;
        this.screenHeight = document.body.clientHeight;
      })();
    };
  },
  methods: {
    getTxtVarCode() {},
    getVerCode() {
      this.$axios
        .get("/oauth/getCode", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var blob = new Blob([response]);
          const a = new FileReader();
          a.readAsDataURL(blob);
          a.onload = (e) => {
            this.validateImg = e.target.result;
          };
        });
    },
    async login() {
      try {
        await this.$refs.form.validate();
        //两个单独的对象
        let postForm = JSON.parse(JSON.stringify(this.form));
        postForm.userPwd = md5(postForm.userPwd);
        let resData = await postData("/oauth/loginByTeacher", postForm);

        //自动登录
        let remeberObj = {
          userCode: this.form.userCode,
          userPwd: window.btoa(this.form.userPwd), //base64加密
        };
        if (this.autoLogin && !timeLocalStorage.get("autoLoginObj")) {
          let date = new Date().getTime();//1000 1s
          timeLocalStorage.set("autoLoginObj",remeberObj, date + 1000*60*60*24*30)
        } 
        
        localStorage.setItem("treeUserId", resData.userId);
        this.$message({
          message: "登录成功！",
          type: "success",
          duration: 2000,
          offset: 150,
        });
        this.$router.push({ path: "/indexLabel" });
      } catch (err) {
        console.log(err);
        //验证码错误
        // if(err.resultCode===20011){
        //   this.getVerCode()
        // }
      }
    },
    reset() {
      this.$refs.form.resetFields();
    },
  },
  watch: {
    screenWidth: {
      //1519
      handler: function (val, oldVal) {
        console.log("width val", val);
        let size = null;
        if (val / 1519 < 0.8) {
          size = 0.8;
        } else if (val / 1519 > 1.2) {
          size = 1.2;
        } else {
          size = val / 1519;
        }
        this.$nextTick(() => {
          this.$refs.information.style.transform = `translate(-50%, -50%) scale(${size})`;
        });
      },
      immediate: true,
    },
  },
};
</script>


<style lang="less" scoped>
.login {
  position: relative;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background: url("../assets/image/login/bg.png");
  background-size: 100% 100%;
  background-color: #21caaa;
  #information-box {
    // border: 1px solid #000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    box-sizing: border-box;
    width: 550px;
    height: 470px;
    .information-tit {
      height: 75px;
      text-align: center;
      img {
        height: 55px;
      }
    }
    .information-login {
      padding: 10px 80px;
      padding-bottom: 20px;
      /deep/#tab-codeQR {
        // padding-left: 80px;
        font-size: 15px;
        padding-right: 70px;
      }
      /deep/#tab-pw {
        font-size: 15px;
        padding-right: 70px;
      }
      /deep/.el-tabs__nav-wrap::after {
        background-color: #fff;
      }
      .code-qr {
        padding: 5px 0px;
        text-align: center;
        .qrPng {
          width: 250px;
          height: 250px;
        }
      }
      .pw-box {
        height: 260px;
        .el-form {
          margin-top: 3px;
          /deep/ .el-input__prefix,
          .el-input__suffix {
            color: @color;
          }
          .loginBtn {
            margin-top: 15px;
            width: 100%;
            color: #fff;
          }
        }
        .save-pw {
          /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
            color: #000000;
            font-size: 13px;
          }
          /deep/ .el-checkbox__label {
            padding-left: 6px;
            font-size: 13px;
          }
          .fr {
            cursor: pointer;
            a {
              color: @color;
            }
          }
        }
        // 验证码
        .validate-container {
          position: relative;
          text-align: left;
          .validateImg {
            position: absolute;
            left: 200px;
            width: 106px;
            height: 39px;
            border-radius: 5px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
